import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useDataProvider, useTranslate } from "react-admin";
import { Delete, ArrowBack } from "@material-ui/icons";

const CalendarEventofDay = (props: any) => {
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const backButonOnClick = () => {
        props.handleBackButton();
    }

    const removeCalendarEvents = () => {
        dataProvider('DELETE', "calendar",
            {
                id: props.eventOfDay?.extendedProps?.calendarEventId,
                data: {
                    room: props.roomData.id
                }
            }).then((res: any) => {
                props.setUpdateCalendarEvents(Math.random());
                props.handleBackButton();
            }).catch((error: any) => {
            });
    }

    const reminderList = [
        {
            text: translate(`pos.messages.reminderNone`),
            value: null
        },
        {
            text: translate(`pos.messages.reminderNone`),
            value: -1
        },
        {
            text: translate(`pos.messages.reminderOnTime`),
            value: 0
        },
        {
            text: translate(`pos.messages.reminder5MinBefore`),
            value: 5
        },
        {
            text: translate(`pos.messages.reminder10MinBefore`),
            value: 10
        },
        {
            text: translate(`pos.messages.reminder15MinBefore`),
            value: 15
        },
        {
            text: translate(`pos.messages.reminder20MinBefore`),
            value: 20
        },
        {
            text: translate(`pos.messages.reminder25MinBefore`),
            value: 25
        },
        {
            text: translate(`pos.messages.reminder30MinBefore`),
            value: 30
        }
    ]

    return (
        <>
            <Button
                variant="contained"
                color='primary'
                style={{ marginLeft: '16px', cursor: 'pointer' }}
                onClick={backButonOnClick}>
                <ArrowBack /><Typography>{translate(`pos.alarm.back`)}</Typography>
            </Button>
            <Button
                variant="contained"
                color='primary'
                style={{ marginLeft: '16px', cursor: 'pointer' }}
                onClick={removeCalendarEvents}>
                <Delete /><Typography>{translate(`pos.alarm.delete`)}</Typography>
            </Button>
            <Grid container item={true} direction="row" xs={12} style={{ padding: '5% 25%' }}>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Title:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{props.eventOfDay?.title}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Type:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography style={{ color: props.eventOfDay?.extendedProps?.dcolor }}>{props.eventOfDay?.extendedProps?.type}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Interval:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{props.eventOfDay?.extendedProps?.interval}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Start:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{props.eventOfDay?.start?.toString()}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Reminder:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{reminderList.find(e => e.value == props.eventOfDay?.extendedProps?.reminder)?.text}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>End:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{props.eventOfDay?.end?.toString()}</Typography>
                    </Grid>
                </Grid>
                <Grid item style={{ cursor: "pointer", padding: '2% 3%' }} xs={12}>
                    <Grid item xs={4}>
                        <Typography variant="h5" style={{ fontWeight: 'bold' }}>Body:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography>{props.eventOfDay?.extendedProps?.body}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default CalendarEventofDay;